import { useEffect, useState, useContext } from "react";
import learnerService from "../../services/learner.service";
import styles from "./ListLearnersPresence.module.css";
import { AuthContext } from "../../contexts/auth.context";
import { useParams } from "react-router-dom";
import ScreenHeader from "../../components/ScreenHeader/ScreenHeader";

function ListLearnersPresencePage() {
  const { section } = useParams();
  const [learners, setLearners] = useState([]);
  const [uniqueDays, setUniqueDays] = useState([]);
  useContext(AuthContext);

  useEffect(() => {
    const fetchLearners = async () => {
      const learners = await learnerService.getLearners(section);

      const days = [
        ...new Set(
          learners.data.reduce(
            (acc, learner) => [...acc, ...learner.presence],
            []
          )
        ),
      ];

      const councilsDays =
        section === "Scouters"
          ? [
              ...new Set(
                learners.data.reduce(
                  (acc, learner) => [...acc, ...learner.councils],
                  []
                )
              ),
            ]
          : [];
      setUniqueDays([...days, ...councilsDays]);

      setLearners(learners.data);
    };

    fetchLearners();
  }, [section]);

  const _getPercent = (learner) => {
    const days =
      learner.presence.length +
      (section === "Scouters" ? learner.councils.length : 0);

    return days ? Math.ceil((days * 100) / uniqueDays.length) : 0;
  };

  const _sortDaysDesc = (days = []) =>
    [...days].sort((a, b) => {
      const [dayA, monthA, yearA] = a.split("-").map(Number);
      const [dayB, monthB, yearB] = b.split("-").map(Number);
      return new Date(yearB, monthB - 1, dayB) - new Date(yearA, monthA - 1, dayA);
    });

  return (
    <>
      <div className={styles["list-container"]}>
        <ScreenHeader title={section} />
        <div className={styles["elementos-lista"]}>
          {learners.length ? (
            learners
              .map((learner) => ({
                ...learner,
                percent: _getPercent(learner),
              }))
              .sort((a, b) => b.percent - a.percent)
              .map((learner) => (
                <div className={styles["learner-elemento"]} key={learner._id}>
                  <div className={styles["learner-head"]}>
                    <div className={styles["name-presence"]}>{learner.name}</div>
                    <div
                      className={`${styles.percent} ${
                        learner.percent > 80
                          ? styles.high
                          : learner.percent > 45
                          ? styles.mid
                          : styles.low
                      }`}
                    >
                      {learner.percent}%
                    </div>
                  </div>

                  <div className={styles["presence-list"]}>
                    <div className={styles["dates-group"]}>
                      <span className={styles["dates-label"]}>Asistencia</span>
                      <div className={styles["dates-wrap"]}>
                        {_sortDaysDesc(learner.presence).length ? (
                          _sortDaysDesc(learner.presence).map((day, i) => (
                            <span className={styles.day} key={`presence-${i}`}>
                              {day.replaceAll("-", "/")}
                            </span>
                          ))
                        ) : (
                          <span className={styles["day-empty"]}>Sin asistencias</span>
                        )}
                      </div>
                    </div>

                    {section === "Scouters" && (
                      <div className={styles["dates-group"]}>
                        <span className={styles["dates-label"]}>Consejo</span>
                        <div className={styles["dates-wrap"]}>
                          {_sortDaysDesc(learner.councils).length ? (
                            _sortDaysDesc(learner.councils).map((day, i) => (
                              <span className={`${styles.day} ${styles.council}`} key={`council-${i}`}>
                                {day.replaceAll("-", "/")}
                              </span>
                            ))
                          ) : (
                            <span className={styles["day-empty"]}>Sin consejos</span>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))
          ) : (
            <p>No hay socios en esta sección</p>
          )}
        </div>
      </div>
    </>
  );
}

export default ListLearnersPresencePage;
